<template>
  <fragment>
    <beneficiario-header hide></beneficiario-header>
    <main class="login-container">
      <div class="bolinha" />

      <div class="linha-1" />

      <div class="linha-2" />

      <div>
        <span class="sub-titulo">LOGIN</span>
      </div>
      <div>
        <div class="text">
          <p>
            Para acessar a área com informações exclusivas, faça o login
            abaixo com suas informações.
          </p>
        </div>
        <div id="carteira-form">
          <masked-input
            placeholder="Carteira Unimed"
            v-model="wallet"
            mask="1 111 111111111111 1"
            class="form-control carteira"
          />
          <span :class="['erro', showMsg]">
            <small>Não foi possivel logar no sistema</small>
          </span>
          <span
            class="btn-enviar spin"
            @click="logar"
          >
            Entrar
          </span>
        </div>
      </div>
    </main>
  </fragment>
</template>

<script>
import InputMask from 'vue-masked-input';
import Header from './layout/Beneficiario-Header.vue';
import { login } from '@/api/beneficiarioApi';

import './style/login.css';

export default {
  name: 'beneficiario-home',
  components: {
    'beneficiario-header': Header,
    'masked-input': InputMask,
  },
  data() {
    return {
      wallet: '',
      showMsg: '',
    };
  },
  mounted() {
    this.loadSession();
  },
  methods: {
    loadSession() {
      const empresa = sessionStorage.getItem('empresa');
      if (empresa) {
        this.$router.push({ path: '/' });
      }
    },
    async logar() {
      try {
        const url = this.wallet.replace(/ /g, '');
        const empresa = await login(url);
        if (empresa && empresa !== 'false') {
          sessionStorage.setItem('empresa', empresa);
          this.showMsg = '';
          this.$router.push({ path: '/' });
        } else {
          this.showMsg = 'erro-show';
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
  },

};
</script>
<style scoped>
input {
  font-size: 16px;
  padding: 10px;
  display: block;
  width: 100%;
  border: 1px solid #b7b7b7;
  border-radius: 5px;
  color: #444;
}
input:focus {
  border-color: #00995d !important;
}
</style>
